




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import StockReport from '@/components/reports/DailyStockReport.vue';
import ReportDate from '@/components/reports/DailyReportDate.vue';
import LevelMixin from '@/mixins/dailyStockReport.mixin';

@Component({
  components: { 
    Title, 
    StockReport, 
    ReportDate 
  },
  mixins: [LevelMixin]
})
export default class DSReport extends Vue {}
